import React from "react";
import { useLocation } from "react-router";
import queryString from "query-string";
import { FundamentalsPageByInvestmentId } from "./FundamentalsPageByInvestmentId";
import { FundamentalsPageByIsin } from "./FundamentalsPageByIsin";

export const FundamentalsPageByLocation = () => {
  const location = useLocation();
  const { investmentId, isin, quoteProvider, tickerSymbol, watchlistEntryId } =
    queryString.parse(location.search);

  if (investmentId) {
    return (
      <FundamentalsPageByInvestmentId
        investmentId={parseInt(investmentId as string, 10)}
      />
    );
  }

  return (
    <FundamentalsPageByIsin
      isin={isin as string}
      quoteProvider={quoteProvider as string}
      tickerSymbol={tickerSymbol as string}
      watchlistEntryId={watchlistEntryId as any}
    />
  );
};
